import { useEffect, useState } from 'react';
import { request } from '../../../helpers/request';
import config from '../../../helpers/config';

interface Team {
  teamName: string;
}

const useTeams = () => {
  const [teams, setTeams] = useState<Team[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchTeams = async () => {
    setLoading(true);
    setError(null);
    try {
      const teamsData: Team[] = await request("GET", `${config.apiUrl}/fulfilment/teams`);
      setTeams(teamsData);
    } catch (err: any) {
      setError(err.message);
      console.error('Error fetching teams:', err);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchTeams();
  }, []);

  return { teams, loading, error, refresh: fetchTeams };
};

export default useTeams;